import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

const StyledGridRootContainer = styled(Grid)({
  position: 'relative',
  height: '100vh',
  alignItems: 'center',
  alignContent: 'unset',
});

export default StyledGridRootContainer;
